'use strict';

var App = require('app');
var ScanDevicesView = require('components/devices/views/common/scan_devices_dialog_view');
var AddDeviceWizard = require('components/devices/views/common/add_device_wizard_view');

var DevicesController = {};

DevicesController.addDevice = function (options) {
    App.showModal(new AddDeviceWizard(options));
};

DevicesController.detectSubDevices = function (options) {
    App.showModal(new ScanDevicesView(options));
};

module.exports = DevicesController;
